module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/tooltip/template.html
// module id = ./components/xo-ui-components/src/tooltip/template.html
// module chunks = 1